import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';

const useHasTestAccessToCarTransportTrucks = () => {
  const me = useMe();

  const hasTestAccessToCarTransporTrucks = useMemo(() => {
    if (!me) {
      return false;
    }

    return !!me.tempTestAccessToCarTransporTrucks;
  }, [me]);

  return hasTestAccessToCarTransporTrucks;
};

export default useHasTestAccessToCarTransportTrucks;
